import React from 'react'
import classnames from 'classnames'
import Img from 'gatsby-image'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'

import styles from './styles'

const Banner = withStyles(styles)(props => {
  const { classes, uid, title, subtitle, image, background = null } = props
  return (
    <div
      className={classnames(
        background
          ? classes.banner_bg
          : classnames(classes.banner, classes[`banner_${uid}`])
      )}
    >
      {image && (
        <img
          sizes={image.src}
          className={classes.bannerLogo}
          alt={image.alt}
          fadeIn={false}
        />
      )}
      {background ? (
        <div
          style={{
            backgroundImage: `url(${background.src})`,
            height: '60vh',
            backgroundSize: 'cover',
            backgroundRepeat: 'none',
          }}
        >
          <BannerContent uid={uid} title={title} subtitle={subtitle} />
        </div>
      ) : (
        <BannerContent uid={uid} title={title} subtitle={subtitle} />
      )}
    </div>
  )
})

const BannerContent = withStyles(styles)(content => {
  const { classes, uid, title, subtitle } = content
  return (
    <div className={classes.contents}>
      <div className={classes.centred}>
        <Grid container spacing={8}>
          <Grid item xs={12}>
            <Typography className={classes.bannerSub}>
              {subtitle.text}
            </Typography>
            <Typography
              className={classnames(
                classes.bannerHead,
                classes[`bannerHead_${uid}`]
              )}
            >
              {title.text}
            </Typography>
          </Grid>
        </Grid>
      </div>
    </div>
  )
})

export default withStyles(styles)(Banner)



// WEBPACK FOOTER //
// ./src/components/banner/index.js